import { render, staticRenderFns } from "./base_info.vue?vue&type=template&id=37abeb72&scoped=true&"
import script from "./base_info.vue?vue&type=script&lang=js&"
export * from "./base_info.vue?vue&type=script&lang=js&"
import style0 from "./base_info.vue?vue&type=style&index=0&id=37abeb72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37abeb72",
  null
  
)

export default component.exports